import React from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

import convertToQueryString from "../../utils/convertToQueryString";
import generatePageLinks from "../../utils/generatePageLinks";
import LinkHandler from "../atoms/LinkHandler";
import Button from "../atoms/Button";

const Pagination = props => {
    const location = useLocation();
    const queryParms = queryString.parse(document.location.search);
    const pathname = location.pathname;
    const { pages, activePage, ellipsisWidth } = props;
    // const pageItems = [];
    const pageLinks = generatePageLinks(pages, activePage, ellipsisWidth);

    const buildPaginationUrl = number => {
        return (
            pathname +
            "?" +
            convertToQueryString({ ...queryParms, page_num: number }, true)
        );
    };

    return (
        <nav className="pagination">
            <div className="row">
                <div className="col-xs-12 col-md-9">
                    {/* Page links */}
                    {pageLinks.map((link, index) => {
                        const activeCls =
                            link === Number(activePage)
                                ? "pagination__link--active"
                                : "";

                        if (isNaN(link)) {
                            return (
                                <span
                                    key={index}
                                    className={`pagination__link`}
                                >
                                    {link}
                                </span>
                            );
                        } else {
                            return (
                                <LinkHandler
                                    key={index}
                                    to={buildPaginationUrl(link)}
                                    className={`pagination__link ${activeCls}`}
                                >
                                    {link}
                                </LinkHandler>
                            );
                        }
                    })}
                </div>
                <div className="col-xs-12 col-md-3">
                    {/* Next arrow */}
                    {activePage < pages ? (
                        <Button
                            className="pagination__next"
                            to={buildPaginationUrl(activePage + 1)}
                            styles={["green"]}
                            aria-label="Show next page"
                        >
                            Show next
                        </Button>
                    ) : null}
                </div>
            </div>
        </nav>
    );
};

export default Pagination;
